import {MatDialog, MatDialogRef} from '@angular/material';
import {ComponentType} from '@angular/cdk/portal';
import {TemplateRef} from '@angular/core';
import {ConfigInterface} from './ModalDialog/ConfigInterface';

export class ModalDialog {

    private nativeMatDialog: MatDialog = null;

    private componentOrTemplateRef: ComponentType<any> | TemplateRef<any> = null;

    private dialogConfig: ConfigInterface = null;

    private dialogRef: MatDialogRef<ComponentType<any> | TemplateRef<any>> = null;

    // ########################################

    constructor(
        nativeMatDialog: MatDialog,
        componentOrTemplateRef: ComponentType<any> | TemplateRef<any>,
        dialogConfig: ConfigInterface
    ) {
        this.nativeMatDialog = nativeMatDialog;
        this.componentOrTemplateRef = componentOrTemplateRef;
        this.dialogConfig = dialogConfig;
    }

    // ########################################

    public open(): MatDialogRef<ComponentType<any> | TemplateRef<any>> {
        this.dialogRef = this.nativeMatDialog.open(this.componentOrTemplateRef, this.dialogConfig);
        this.afterClosedSubscribe();
        this.afterOpenSubscribe();
        this.beforeClosedSubscribe();
        this.backdropClickSubscribe();

        return this.dialogRef;
    }

    public close(): void {
        this.dialogRef.close();
    }

    public closeAll(): void {
        this.nativeMatDialog.closeAll();
    }

    // ########################################

    private afterClosedSubscribe(): void {
        const afterClosedFn = this.dialogConfig.afterClosedFn;

        if (afterClosedFn) {
            this.dialogRef.afterClosed().subscribe(afterClosedFn);
        }
    }

    private afterOpenSubscribe(): void {
        const afterOpenFn = this.dialogConfig.afterOpenFn;

        if (afterOpenFn) {
            this.dialogRef.afterOpen().subscribe(afterOpenFn);
        }
    }

    private beforeClosedSubscribe(): void {
        const beforeClosedFn = this.dialogConfig.beforeClosedFn;

        if (beforeClosedFn) {
            this.dialogRef.beforeClose().subscribe(beforeClosedFn);
        }
    }

    private backdropClickSubscribe(): void {
        const backdropClickFn = this.dialogConfig.backdropClickFn;

        if (backdropClickFn) {
            this.dialogRef.backdropClick().subscribe(backdropClickFn);
        }
    }

    // ########################################
}
